import { createBundle } from "../../api/inventoryService";

export const useCreateBundle = (successCallback) => {
    const create = async (data) => {
        try {
            const newRecord = await createBundle(data);
            if (successCallback)
            {
                successCallback(newRecord);
            }
            return newRecord;
        } catch (error) {
            console.error("Failed to create bundle:", error);
            throw error; // rethrow so the component can handle errors
        }
    };

  return { create };
};